import React, { Component, Suspense } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { CSpinner } from '@coreui/react-pro'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './scss/style.scss'
import Login from './views/login/Login'
import { AuthProvider } from './hooks/useAuth'
import { ProtectedRoute } from './components/ProtectedRoute'
import { ToastProvider } from './hooks/useToast'

const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
})

class App extends Component {
  render(): JSX.Element {
    return (
      <QueryClientProvider client={queryClient}>
        <HashRouter>
          <Suspense fallback={<CSpinner color="primary" />}>
            <AuthProvider>
              <ToastProvider>
                <Routes>
                  <Route
                    path="*"
                    element={
                      <ProtectedRoute>
                        <DefaultLayout />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="/login" element={<Login />} />
                </Routes>
              </ToastProvider>
            </AuthProvider>
          </Suspense>
        </HashRouter>
      </QueryClientProvider>
    )
  }
}

export default App
